/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '0.0.0';
export const PublishedData = {
    type: 'object',
    properties: {
        cabinetMaterials: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string'
                    },
                    color: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                type: 'null'
                            }
                        ]
                    },
                    materialName: {
                        type: 'string',
                        enum: [
                            'lightWoodMaterial',
                            'darkWoodMaterial',
                            'whiteWoodMaterial',
                            'butcherBlockMaterial',
                            'cabinetBodyMaterial',
                            'countertopMaterial'
                        ]
                    },
                    swatchUrl: {
                        type: [
                            'null',
                            'string'
                        ]
                    }
                },
                required: [
                    'name',
                    'color',
                    'materialName',
                    'swatchUrl'
                ],
                additionalProperties: false,
                declared: true,
                tsType: 'MaterialType',
                import: [
                    {
                        module: './model/index.js',
                        member: 'MaterialType',
                        doNotImportInto: [
                            './model/v',
                            './admin-model/v'
                        ]
                    }
                ]
            }
        },
        countertopMaterials: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string'
                    },
                    color: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                type: 'null'
                            }
                        ]
                    },
                    materialName: {
                        type: 'string',
                        enum: [
                            'lightWoodMaterial',
                            'darkWoodMaterial',
                            'whiteWoodMaterial',
                            'butcherBlockMaterial',
                            'cabinetBodyMaterial',
                            'countertopMaterial'
                        ]
                    },
                    swatchUrl: {
                        type: [
                            'null',
                            'string'
                        ]
                    }
                },
                required: [
                    'name',
                    'color',
                    'materialName',
                    'swatchUrl'
                ],
                additionalProperties: false,
                declared: true,
                tsType: 'MaterialType',
                import: [
                    {
                        module: './model/index.js',
                        member: 'MaterialType',
                        doNotImportInto: [
                            './model/v',
                            './admin-model/v'
                        ]
                    }
                ]
            }
        },
        segmentPrices: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    productCode: {
                        type: 'string'
                    },
                    materialType: {
                        type: 'string'
                    },
                    width: {
                        type: 'number'
                    },
                    price: {
                        type: 'number'
                    }
                }
            }
        },
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        type: 'string'
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    type: 'string'
                                },
                                description: {
                                    type: 'string'
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    type: 'string'
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        }
    },
    additionalProperties: false,
    required: [
        'cabinetMaterials',
        'countertopMaterials'
    ]
};
export const SessionData = {
    type: 'object',
    properties: {
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: [
        'tags'
    ]
};
export const FrontendData = {};
export const FinalizeData = {
    type: 'object',
    properties: {
        session: {
            type: 'string'
        },
        emailAddress: {
            type: 'string'
        },
        addToCartUrl: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: []
};
export const PrefetchedFinalizeData = {};
export const FinalizeResult = {};
export const CallbackData = {};
export const BackendData = undefined;
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Default'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        'Default'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Default'
    ]
});
export const ExportState = new EnumReflection('ExportState', {
    enum: [
        'Default'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'SegmentPrices',
        'CabinetColors',
        'CountertopColors'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});
export const $dataSpec = {
    custom: {},
    swatchOptions: {}
};

//# sourceMappingURL=application-types.js.map